module.exports = __webpack_public_path__ + "img/share-Qzone.67d716e1.png";